// src/pages/StudentSuggestions.js

import React, { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { db } from "../firebase";
import {
  collection,
  addDoc,
  Timestamp,
  doc,
  getDoc,
} from "firebase/firestore";

function StudentSuggestions() {
  const [suggestion, setSuggestion] = useState("");
  const [status, setStatus] = useState("");
  const [schoolId, setSchoolId] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (u) => {
      if (u) {
        setUser(u);
        const userSnap = await getDoc(doc(db, "users", u.uid));
        if (userSnap.exists()) {
          const data = userSnap.data();
          setSchoolId(data.schoolId || null);
        }
      }
    });
    return () => unsubscribe();
  }, []);

  const handleSubmit = async () => {
    if (!suggestion.trim()) {
      alert("Please enter a suggestion.");
      return;
    }

    if (!schoolId || !user) {
      alert("Missing user or school info.");
      return;
    }

    try {
        const ref = collection(db, "schools", schoolId, "studentSuggestions");
        await addDoc(ref, {
            itemName: suggestion.trim(),
            studentId: user.uid,
            studentName: user.displayName || "Unknown",
            timestamp: Timestamp.now(),
          });
      setSuggestion("");
      setStatus("✅ Suggestion submitted!");
    } catch (err) {
      console.error("Failed to submit suggestion:", err);
      setStatus("❌ Failed to submit.");
    }
  };

  return (
    <div style={{ padding: "2rem", maxWidth: "600px", margin: "0 auto" }}>
      <h1>💡 Suggest a Store Item</h1>
      <p>Have an idea for a new Store Item? Let us know!</p>

      <textarea
        value={suggestion}
        onChange={(e) => setSuggestion(e.target.value)}
        rows={5}
        placeholder="Type your suggestion here..."
        style={{ width: "100%", padding: "1rem", borderRadius: "8px" }}
      />

      <button
        onClick={handleSubmit}
        style={{
          marginTop: "1rem",
          padding: "0.5rem 1rem",
          backgroundColor: "#3b82f6",
          color: "white",
          borderRadius: "6px",
        }}
      >
        Submit Suggestion
      </button>

      {status && <p style={{ marginTop: "1rem" }}>{status}</p>}
    </div>
  );
}

export default StudentSuggestions;